import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";
import ModalConfirm from "UI/ModalConfirm";
import { Tray } from "Components/Sidebar";

export default class ElementPropertiesSidebarTray extends React.Component
{
    state = {
        deleting: false
    };

    static propTypes = {
        element: PropTypes.object.isRequired,
        removeElement: PropTypes.func.isRequired,
    };

    onClick = () => {
        this.setState({deleting: true});
    };

    onConfirm = () => {
        this.props.removeElement(this.props.element.id).then(() => {
            this.setState({deleting: false})
        });
    };

    onClose = () => {
        this.setState({deleting: false});
    };

    render()
    {
        return <Tray>
            <Button type='danger' className='w-full justify-center' onClick={this.onClick}>Remove Element</Button>
            <ModalConfirm danger open={this.state.deleting} onConfirm={this.onConfirm} onClose={this.onClose}>
                Are you sure you wish to remove this element?
            </ModalConfirm>
        </Tray>;
    }
}
